import React from "react";

function ActiveSalesDetailsTab({ mockData }) {
  if (!mockData) return null;

  const investmentDetails = [
    {
      label: "Allocated cost per unit",
      value: mockData.allocatedCostPerUnit,
    },
    {
      label: "Projected min. value per unit",
      value: mockData.projectedMinValue,
    },
    {
      label: "Estimated return / unit (min.)",
      value: mockData.estimatedReturnPerUnit,
    },
    {
      label: "Construction tenure",
      value: mockData.constructionTenure,
    },
    {
      label: "Sales window",
      value: mockData.salesWindow,
    },
    {
      label: "Time remaining in sales tenure",
      value: mockData.timeRemaining,
    },
  ];

  return (
    <div className="border border-gray-100 rounded-xl p-5 shadow-sm bg-white">
      <h3 className="text-[#14013A] font-[700] text-[14px] mb-4">
        Your Position
      </h3>

      {/* Investment Details */}
      {investmentDetails.map(({ label, value }, index) => (
        <div
          key={label}
          className={`flex justify-between gap-4 py-3 ${
            index !== investmentDetails.length - 1
              ? "border-b border-gray-50"
              : ""
          }`}
        >
          <p className="text-[#14013A] font-[500] text-[13px]">{label}</p>

          <p className="text-[#14013A] text-[12px] font-[600] text-right">
            {value ?? "N/A"}
          </p>
        </div>
      ))}

      {/* Construction and Sales Status */}
      <div className="flex flex-wrap justify-between items-center gap-3 pt-4">
        <div className="flex items-center gap-1">
          <span className="text-[#00BC67] font-[600] text-[13px]">
            Construction:
          </span>

          <span className="text-[#00BC67] text-[12px] font-[400]">
            {mockData.constructionStatus ?? "N/A"}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <span className="text-[#00BC67] font-[600] text-[13px]">
            Sales window:
          </span>

          <span className="text-[#00BC67] text-[12px] font-[400]">
            {mockData.salesWindowStatus ?? "N/A"}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ActiveSalesDetailsTab;
